import { useQuery } from "@tanstack/react-query"
import { get } from "api/requests"


const getListTargetGroup =  (params) => get(`target-group/list`, params)

export const useListTargetGroup = (params) => {
  return useQuery(['target-group'], () => getListTargetGroup(params))
}